/*eslint-disable*/
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../../components/CircularLoading";
import { features, language } from "config";
import { FirebaseContext } from "common";
import AlertDialog from "../../components/AlertDialog";
import Material_React_Table from "../../components/CustomTable/BrokerMaterialTable";
import { Box } from "@mui/material";

export default function AddStaffAdmin(props) {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    editUser,
    deleteUser,
    checkUserExists,
    emailSignUp,
    clearLoginError,
    AddP24,
    AddWebsite,
    editBrokerApproval
  } = api;

  const branchManagementReducer = useSelector((state) => state.branchData);
  const auth = useSelector((state) => state.auth);
  const usersdata = useSelector((state) => state.usersdata);
  const branchData = useSelector((state) => state.branchData.branches);
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [officeData, setOfficeData] = useState();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });
  const [loading, setLoading] = useState({ isloading: false, reason: "" });

  const branchLookup = Array.isArray(branchManagementReducer.branches)
    ? branchManagementReducer.branches.reduce((lookup, branch) => {
        // console.log("Branch", branch);

        lookup[branch.branchId] = branch.BranchName;
        return lookup;
      }, {})
    : {};

  // console.log('branchLookup', branchLookup)

  useEffect(() => {
    let arr2 = [];

    if (branchData) {
      console.log("Branch Data:", branchData); // Log branch data to verify data
      for (let index = 0; index < branchData.length; index++) {
        const element = branchData[index];

        // Populate the list with all branches, remove brokerHomeOffice filter
        if (element.BranchName === auth?.info?.profile?.adminHomeOffice) {
          arr2.push({
            value: element.branchId, // The branch ID (or name if preferred)
            label: `${element.BranchName}` // Branch name
          });
        }
      }
      setOfficeData(arr2.sort((a, b) => a.label.localeCompare(b.label)));
      console.log("Branch List:", arr2); // Log branch list to verify population
    }
  }, [branchData]);

  useEffect(() => {
    if (usersdata.users) {
      setData(usersdata.users.filter((user) => user.userType === "broker"));
    } else {
      setData(usersdata.users);
    }
  }, [usersdata.users]);

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
    if (auth.error.flag) {
      dispatch(clearLoginError());
    }
  };

  const renderStatus = (active) => {
    const isActive = !!active;

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: isActive ? "#27ae60" : "#e74c3c",
          color: "#fff",
          fontWeight: "bold",
          fontSize: 18
        }}
        title={isActive ? "Active" : "Inactive"}
      >
        {isActive ? "✔" : "✖"}
      </span>
    );
  };

  const columns = [
    {
      id: "id",
      header: "Hidden id",
      columns: [
        {
          accessorKey: "id",
          header: "User id",
          enableEditing: false,
          Edit: () => null, //don't render anything in the editing modal for this column
          //or Edit: ({ cell, renderedCellValue }) => <>{renderedCellValue}</>, //render the normal cell value instead of a text field
          enableHiding: true
        }
      ]
    },
    {
      accessorKey: "firstName",
      header: language.first_name
    },
    {
      accessorKey: "lastName",
      header: language.last_name
    },
    {
      accessorKey: "agentId",
      header: "Property 24",
      Cell: ({ cell, row }) => renderStatus(cell.getValue()),
      size: 160
    },
    {
      accessorKey: "PPagentId",
      header: "Private Property",
      Cell: ({ cell, row }) => renderStatus(cell.getValue()),
      size: 160
    },
    {
      accessorKey: "websiteID",
      header: "Website",
      Cell: ({ cell, row }) => renderStatus(cell.getValue()),
      size: 160
    },
    {
      accessorKey: "identityNumber",
      header: "Identity Number"
    },
    {
      accessorKey: "email",
      header: language.email,
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo"
    },
    {
      accessorKey: "password",
      header: "Password"
    },
    {
      accessorKey: "mobile",
      header: language.mobile,
      Cell: ({ cell }) =>
        features.AllowCriticalEditsAdmin ? cell.getValue() : "Hidden for Demo"
    },
    {
      accessorKey: "brokerHomeOffice",
      header: "Office",
      enableEditing: true
    },
    {
      accessorKey: "approved",
      header: language.account_approve,
      Cell: ({ cell }) => (cell.getValue() ? "Yes" : "No")
    }
  ];

  // const handleAddRow = async (newRow) => {
  //   const res = await checkUserExists(newRow);
  //   if (res.users && res.users.length > 0) {
  //     alert(language.user_exists);
  //   } else if (res.error) {
  //     alert(language.email_or_mobile_issue);
  //   } else {
  //     newRow["createdByAdmin"] = true;
  //     newRow["userType"] = "broker";
  //     newRow["brokerHomeOffice"] = branchLookup[newRow.brokerHomeOffice];
  //     newRow["createdAt"] = new Date().toISOString();
  //     newRow["referralId"] =
  //       newRow.firstName.toLowerCase() +
  //       Math.floor(1000 + Math.random() * 9000).toString();
  //     newRow["username"] =
  //       newRow.firstName.toLowerCase() +
  //       newRow.lastName.toLowerCase() +
  //       Math.floor(1000 + Math.random() * 9000).toString();

  //     const role = auth.info.profile.userType;
  //     if (role === "broker") {
  //       newRow["broker"] = auth.info.uid;
  //     }

  //     const result = await emailSignUp(newRow);
  //     if (result.uid) {
  //       setCommonAlert({
  //         open: true,
  //         msg: language.account_create_successfully,
  //       });
  //     } else {
  //       setCommonAlert({
  //         open: true,
  //         msg: language.reg_error,
  //       });
  //     }
  //   }
  // };

  // const handleUpdateRow = (updatedRow) => {
  //   console.log("New Data in update broker method:", updatedRow);
  //   console.log("Branchs :", branchManagementReducer.branches);
  //   console.log("Inputed manager :", updatedRow.manager);
  //   console.log("Branch Lookup Object:", branchLookup);

  //   console.log("Matched branch :", branchLookup[updatedRow.brokerHomeOffice]);

  //   updatedRow["brokerHomeOffice"] = branchLookup[updatedRow.brokerHomeOffice];
  //   if (!(updatedRow.brokerHomeOffice)) {
  //     return console.log("Broker Home Office is undefined");

  //   }
  //   dispatch(editUser(updatedRow.id, updatedRow));
  // };

  // const handleDeleteRow = (rowToDelete) => {
  //   if (features.AllowCriticalEditsAdmin) {
  //     dispatch(deleteUser(rowToDelete.id));
  //   } else {
  //     alert(language.demo_mode);
  //   }
  // };

  const PublishtoPP = (row) => {
    AddP24;
    dispatch(AddP24(row, row.id));
  };

  const PublishToWebsite = (row) => {
    dispatch(AddWebsite(row, row.id));
  };

  const handleApproveBroker = (rowData) => {
    dispatch(editBrokerApproval(rowData));
  };

  return loading.isloading || usersdata.loading ? (
    <CircularLoading label={loading.reason} />
  ) : (
    <Box>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>
      <Material_React_Table
        data={data}
        columns={columns}
        userInitialState={{
          columnVisibility: { id: false } // This hides the "id" column initially
        }}
        PublishtoPP={PublishtoPP}
        PublishToWebsite={PublishToWebsite}
        officeData={officeData}
        handleApproveBroker={handleApproveBroker}
      />
    </Box>
  );
}
